export const BIAS_FEATURE_FLAG = 'bias-analytics';
export const FINDING_VOLUME_DEMO_FEATURE_FLAG = 'finding-volume-demo';
